import { useState } from 'react';
import AiFloatingPanel from './AiFloatingPanel';
import ChatFloating from './ChatFloating';

export default function FloatingButtons() {
  const [chat, setChat] = useState(false);
  const [ai, setAi] = useState(false);
  return (
    <>
      <div className="fab-stack">
        <button
          className="fab fab-chat"
          title="Chat direct"
          onClick={() => {
            setChat((v) => !v);
            setAi(false);
          }}
        >
          💬
        </button>
        <button
          className="fab fab-ia"
          title="Assistant IA"
          onClick={() => {
            setAi((v) => !v);
            setChat(false);
          }}
        >
          ✦
        </button>
      </div>
      <ChatFloating open={chat} onClose={() => setChat(false)} />
      <AiFloatingPanel open={ai} onClose={() => setAi(false)} />
    </>
  );
}
